import React from 'react';
import { useReport } from './hooks/Report.hook';
import ReportView from './views/ReportView';
import LoadingComponent from '@/components/general/Loading/LoadingComponent';

const ReportController = () => {
  const { isLoading, reportData, activeTab, setActiveTab, patientData } = useReport();

  if (isLoading) {
    return <LoadingComponent loading={isLoading} />;
  }

  return (
    <ReportView
      reportData={reportData}
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      patientData={patientData}
    />
  );
};

export default ReportController;
